import { render, staticRenderFns } from "./TeamFormDialog.vue?vue&type=template&id=181e7793"
import script from "./TeamFormDialog.vue?vue&type=script&lang=js"
export * from "./TeamFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports